module.exports = __webpack_public_path__ + "static/media/background-gradation-Tablet.94008199.png";